import { Component } from '@angular/core';
import { GetPostplaceParams, PostplaceGet } from '../postplace.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-postplace-view',
    templateUrl: './postplace-view.component.html',
    styleUrls: ['./postplace-view.component.css'],
})
export class PostplaceViewComponent {
    public params: GetPostplaceParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as GetPostplaceParams;
    }

    public onSubmit(_: PostplaceGet) {
        this.state.back();
    }
}
